import { render, staticRenderFns } from "./CategoryNew.vue?vue&type=template&id=6b043062&"
import script from "./CategoryNew.vue?vue&type=script&lang=js&"
export * from "./CategoryNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports